export default {
    dependencies: ['$element', 'trackingservice'],
    callable(element, trackingService) {
        const widgetContainer = element.querySelector(
            '[data-finnbox-id=widget_container]'
        );
        const summaryElement = element.querySelector(
            '[data-finnbox-id=widget_summary]'
        );
        const widget = FINN.finnbox.conversationsWidget.create(widgetContainer);
        let initialized = false;
        let collapsed = true;

        init();

        function expand() {
            if (initialized) {
                widget.refresh();
            } else {
                widget.init();
                initialized = true;
            }
            collapsed = false;
        }

        function collapse() {
            collapsed = true;
        }

        function init() {
            summaryElement.addEventListener('click', () => {
                if (collapsed) {
                    expand();
                    trackingService.trackEventObject({
                        analyticsName:
                            'contact.contact-from-object-page.show-widget',
                        eventFlags: 'start,success',
                    });
                } else {
                    collapse();
                    trackingService.trackEventObject({
                        analyticsName:
                            'contact.contact-from-object-page.hide-widget',
                        eventFlags: '',
                    });
                }
            });
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/finnboxWidget.js